import { useCallback } from 'react'
import { captureException } from '@thriveglobal/thrive-web-core'
import { findAzureConfig, processIdpConfig } from '../utils/handleIdpConfig'
import { IdpConfig } from '../graphql/generated/autogenerated'

interface useSignInWithMicrosoftType {
    idpConfigs: Array<IdpConfig>
    email: string
    setShowErrorAlert: (showErrorAlert: boolean) => void
}

function useSignInWithMicrosoft({
    idpConfigs,
    email,
    setShowErrorAlert
}: useSignInWithMicrosoftType) {
    const signInWithMicrosoft = useCallback(async (): Promise<boolean> => {
        try {
            const azureConfig = findAzureConfig(idpConfigs)
            if (!azureConfig) {
                setShowErrorAlert(true)
                captureException(
                    new Error('Signup Method: unable to find azure config')
                )
                return false
            }
            processIdpConfig(azureConfig, email)
            return true
        } catch (error) {
            captureException(error, {
                message: 'useSignInWithMicrosoft failed with unknown error'
            })
            return false
        }
    }, [idpConfigs])
    return signInWithMicrosoft
}

export default useSignInWithMicrosoft
